import {
  DeleteOutlined,
  EditOutlined,
  FolderViewOutlined,
} from "@ant-design/icons";
import { COLOR_TOOLTIP } from "@constants/common";
import { Button, Tooltip } from "antd";
import { TableProps } from "antd/lib";
import { SECTOR_PAGE_CONSTANT } from "./constant";
import { TListSectorTable } from "@models/sector";

const { TITLE, TABLE_KEY } = SECTOR_PAGE_CONSTANT;

const renderCodeName = (record: any) => {
  return `${record.companyCode}_${record.companyName}`;
};

export const getColumns = ({
  handleOpenModalDelete,
  handleOpenModalDetail,
  handleOpenModalUpdate,
}: {
  handleOpenModalDelete: (record: TListSectorTable) => void;
  handleOpenModalDetail: (record: TListSectorTable) => void;
  handleOpenModalUpdate: (record: TListSectorTable, id: string) => void;
}): TableProps<TListSectorTable>["columns"] => {
  return [
    {
      title: TITLE.NO,
      key: TABLE_KEY.NO,
      dataIndex: TABLE_KEY.NO,
      align: "center",
      width: 60,
    },
    {
      title: TITLE.COMPANY_ID,
      key: TABLE_KEY.COMPANY_CODE,
      dataIndex: TABLE_KEY.COMPANY_CODE,
      align: "center",
      width: 200,
      render: (_, record) => {
        if (record) {
          const codeName = renderCodeName(record);
          return (
            <div className="list-page_ellipsis">
              <Tooltip
                color="white"
                overlayClassName="common_custom-tooltip"
                title={codeName}
                overlayInnerStyle={{
                  color: COLOR_TOOLTIP,
                }}
              >
                {codeName}
              </Tooltip>
            </div>
          );
        }
        return null;
      },
    },
    {
      title: TITLE.SECTOR_CODE,
      key: TABLE_KEY.SECTOR_CODE,
      dataIndex: TABLE_KEY.SECTOR_CODE,
      align: "center",
      width: 200,
      render: (_, record) => {
        if (record) {
          return (
            <div className="list-page_ellipsis">
              <Tooltip
                color="white"
                overlayClassName="common_custom-tooltip"
                title={record.sectorCode}
                overlayInnerStyle={{
                  color: COLOR_TOOLTIP,
                }}
              >
                {record.sectorCode}
              </Tooltip>
            </div>
          );
        }
        return null;
      },
    },
    {
      title: TITLE.SECTOR_NAME,
      key: TABLE_KEY.SECTOR_NAME,
      dataIndex: TABLE_KEY.SECTOR_NAME,
      align: "center",
      width: 300,
      render: (_, record) => {
        if (record) {
          return (
            <div className="list-page_ellipsis">
              <Tooltip
                color="white"
                overlayClassName="common_custom-tooltip"
                title={record.sectorName}
                overlayInnerStyle={{
                  color: COLOR_TOOLTIP,
                  whiteSpace: "pre-wrap",
                }}
              >
                <div style={{ whiteSpace: "pre-wrap" }}>
                  {record.sectorName}
                </div>
              </Tooltip>
            </div>
          );
        }
        return null;
      },
    },
    {
      title: TITLE.ACTION,
      align: "center",
      width: 170,
      render(_, record) {
        return (
          <div className="list-page_modal-btns">
            <Button
              onClick={() => {
                handleOpenModalDetail(record);
              }}
            >
              <FolderViewOutlined
                style={{
                  fontSize: "21px",
                  color: "#344054",
                  cursor: "pointer",
                }}
              />
            </Button>
            <Button
              onClick={() => {
                handleOpenModalUpdate(record, record.id);
              }}
            >
              <EditOutlined
                style={{
                  fontSize: "21px",
                  color: "#344054",
                  cursor: "pointer",
                }}
              />
            </Button>
            <Button
              onClick={() => {
                handleOpenModalDelete(record);
              }}
            >
              <DeleteOutlined
                style={{
                  fontSize: "21px",
                  color: "#F04438",
                  cursor: "pointer",
                }}
              />
            </Button>
          </div>
        );
      },
    },
  ];
};
